export const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const passwordPattern = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()?<>/|_=+±])(?=.{8,}).*$/;
// Password must contain at least 8 characters, including 1 uppercase letter, 1 number, and 1 symbol (!, $, @, *, etc)
